import RemoveUsersGroupModal from './RemoveUsersGroupModal';

export default RemoveUsersGroupModal;
